module.exports = __webpack_public_path__ + "img/21.36256208.png";